import { API_ERROR_CODES } from 'modules/application/constants';
import { registrationPageTitles } from 'routes';

export const getIsDev = () => window.location.hostname === 'localhost';

export const getIsProd = () =>
  window.location.hostname === 'invite-user.digital.business.comcast.com';

export const formatResponse = (response) => {
  const responseData = response?.data?.data || response?.data;

  return {
    body: responseData || response?.error || {},
    messages: response?.data?.messages,
    status: response?.status || null,
  };
};

export function getErrorCodes(response) {
  return response?.messages?.map((message) => message.code) || [];
}

export const getErrorTrackingMessage = (errorCodes, pageError) => {
  return {
    eventAction: pageError?.eventAction || `${document.title} error`,
    eventName: 'invite a user transaction error',
    attributes: {
      errorMessage:
        pageError?.errorMessage || `FMARR | ${getErrorMessageByErrorCode()}`,
    },
  };
};

export const getRegistrationTrackingMessage = (screenName) => {
  const isOnRegistrationTrackingPage = Object.values(
    registrationPageTitles
  ).includes(screenName);

  if (isOnRegistrationTrackingPage) {
    return {
      fmarr: `invited user registration ${
        screenName === registrationPageTitles.primaryInvite
          ? 'start'
          : 'complete'
      }`,
    };
  }
  return {};
};

export const getRegistrationErrorTrackingMessage = (errorCodes) => {
  return {
    eventAction: 'registration',
    eventName: 'registration',
    eventPage: window?.digitalData?.page?.pageInfo?.pageName,
    registrationError: errorCodes.length
      ? errorCodes.reduce(
          (registrationErrorMessage, currentErrorCode) =>
            `${registrationErrorMessage} | ${getErrorMessageByErrorCode(
              currentErrorCode
            )}`,
          'FMARR Error'
        )
      : `FMARR Error | ${getErrorMessageByErrorCode()}`,
    registrationFlowType: 'FMARR | Invite a User',
  };
};

const getErrorMessageByErrorCode = (errorCode) => {
  switch (errorCode) {
    case API_ERROR_CODES.accountAlreadyRegistered:
    case API_ERROR_CODES.userPreviouslyRegistered:
      return 'already registered';
    case API_ERROR_CODES.invalidCaptcha:
      return 'invalid captcha';
    case API_ERROR_CODES.invalidJWT:
      return 'session timeout';
    case API_ERROR_CODES.inviteExpirationNotSet:
    case API_ERROR_CODES.inviteExpiredOrNotFound:
      return 'invitation expired';
    case API_ERROR_CODES.inviteMissingEmail:
      return 'missing email';
    case API_ERROR_CODES.inviteMissingZipCode:
      return 'error loading start page';
    case API_ERROR_CODES.inviteRetrievalFailure:
      return 'failed to retrieve invite';
    case API_ERROR_CODES.passwordBanned:
    case API_ERROR_CODES.passwordInvalid:
      return 'invalid password';
    case API_ERROR_CODES.securityQuestionInvalid:
      return 'invalid security question';
    case API_ERROR_CODES.securityQuestionsRetrievalFailure:
      return 'failed to retrieve security questions';
    case API_ERROR_CODES.zipCodeMismatch:
      return 'zip code error';
    default:
      return 'something went wrong';
  }
};
